import * as express from 'express';
import {AuthenticationMiddlewareContract} from 'common/http/AuthenticationMiddlewareContract';
import {AuthentificationConfigurationContract} from 'common/http/AuthentificationConfigurationContract';
import {UnauthorizedException} from 'common/exception/UnauthorizedException';
import {HandlerController} from 'common/http/HandlerController';

export class AuthenticationMiddleware implements AuthenticationMiddlewareContract {
    private configuration: AuthentificationConfigurationContract;

    public constructor(configuration: AuthentificationConfigurationContract) {
        this.configuration = configuration;
    }

    public handler(): (request: express.Request, response: express.Response, next: () => void) => void {
        return (request: express.Request, response: express.Response, next: () => void) => {
            try {
                let authenticated: boolean = false;

                if (!authenticated && this.configuration.jwt !== undefined) {
                    (request as any).session = {
                        // TODO
                    };

                    authenticated = true;
                }

                if (!authenticated && this.configuration.key !== undefined) {
                    authenticated = this.authApiKey(request);
                }

                if (!authenticated && this.configuration.session !== undefined) {
                    const sessionKeys: string[] = Object.keys((request as any).session);
                    if (!Array.isArray(this.configuration.session.required)) {
                        throw new UnauthorizedException('session is not well formatted');
                    }

                    this.configuration.session.required.forEach((required) => {
                        if (!sessionKeys.includes(required)) {
                            throw new UnauthorizedException('session is incomplete');
                        }
                    });

                    authenticated = true;
                }

                if (!authenticated && this.configuration.none !== undefined) {
                    authenticated = this.authNone(request);
                }

                if (authenticated) {
                    next();
                } else {
                    throw new UnauthorizedException('request is not authenticate');
                }
            } catch (error) {
                HandlerController.error(request, response, error);
            }
        };
    }

    private authApiKey(request: express.Request): boolean {
        if (typeof request.headers.Authorization !== 'string' || !request.headers.Authorization.startsWith('apiKey')) {
            return false;
        }

        const parts: string[] = request.headers.Authorization.split(' ');
        if (parts.length !== 2) {
            throw new UnauthorizedException('api key is not well formatted');
        }

        if (parts[1] !== this.configuration.key.secret) {
            throw new UnauthorizedException('api key is not valid');
        }

        (request as any).session = {};

        return true;
    }

    private authNone(request: express.Request): boolean {
        if (Array.isArray(this.configuration.none.urlStartsWith)) {
            if (this.configuration.none.urlStartsWith.find((urlStartsWith) => request.originalUrl?.startsWith(urlStartsWith)) !== undefined) {
                (request as any).session = {};

                return true;
            }
        }

        return false;
    }
}
